import Title from '@/components/ui/Title'

const Animation = () => {
  return (
    <div className="py-4 w-full px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="Animation" />
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Stop Motion"
          src="https://www.youtube.com/embed/uHrvawXgAq4"
        />
      </div>
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Fundamentals"
          src="https://www.youtube.com/embed/Cbl6w5-mE0I"
        />
      </div>
      <div className="flex-row justify-center flex">
        <iframe
          className="aspect-video w-full md:w-[75%]"
          title="Lip Sync 2D"
          src="https://www.youtube.com/embed/GZ-ET2YUqlE"
        />
      </div>
    </div>
  )
}

export default Animation
